import React from 'react';

import PlanCard from './PlanCard/PlanCard';
import ShowAllButton from '../ShowAllButton/ShowAllButton';

const Recommendations = props => {
  let { plans, phoneAlert } = props;
  const plansLength = plans.length;
  if (!(plans && plans.length)) {
    return null;
  }
  if (!props.showAll) {
    plans = plans.slice(0, 3);
  }
  const isMobile = window.innerWidth <= 960;

  const divideArray = (array, n) => {
    let idx = 0;
    const results = [];
    const length = array.length;

    while (idx + n < length){
        const result = array.slice(idx,idx+n)
        results.push(result);
        idx = idx + n;
    }

    const rest = array.slice(idx,length+1)
    if (array.length > 3) {
      while (rest.length < n){
          rest.push({ dummy: true });
      }
    }
    results.push(rest);
    return results;
  }

  const columnNumber = isMobile ? 1 : 3;
  const divided = divideArray(plans, columnNumber)

  const onlyPhoneAlert = phoneAlert ? (
    <div className="PhoneAlert" >
      申し訳ございませんがお電話のみでのご加入はいただけません。
    </div>
  ) : null;

  return (
    <div style={{ ...props.style }} className="Recommendation">
      <div className="RecommendationTitle">
        <div className="RecommendationTitleText" >
          {props.title}
        </div>
      </div>
      {onlyPhoneAlert}
      {divided.map((plans, index) => {
        const justifyContent = isMobile || index === 0 ? 'center' : 'center';
        return (
          <div key={index} className="PlanContainer" style={{ justifyContent }} >
            {plans.map((plan, index) => (
              <PlanCard
                first={index===0}
                key={index}
                plan={plan}
                onClick={() => props.onClick(plan)}
              />
            ))}
          </div>
        )
      })}
      <ShowAllButton show={plansLength > 3 && !props.showAll} onClick={props.handleShowAll} />
    </div>
  );
  };

export default Recommendations;
